import {ISVPlayer, svPlayerType} from "./interfaces";
import React, {useEffect, useState} from "react";
import PlayAudioIcon from "../../../ui/svg/audio/play-audio";
import {Toggle} from "../../../ui/toggle/toggle";
import {cloneDeep, groupBy, keys} from "lodash";
import StopAudioIcon from "../../../ui/svg/audio/stop-audio";

interface ISVPlayerProps {
    svPlayerSources?: ISVPlayer[],
    elId:number,
    svPlayerType:svPlayerType
}
/**
/**
 * the entry point
 */
const SVPlayer2 = (props?: ISVPlayerProps) => {

    const ImageCDNDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase();
    const AudioCDNDomain = 'https://assets.wavescdn.com';
    const [isFirstTimeSelected, setIsFirstTimeSelected] = useState<boolean>(false);
    const [currentPlayer, setCurrentPlayer] = useState<ISVPlayer>();
    const [selectedStylePlayer, setSelectedStylePlayer] = useState<ISVPlayer>();
    const [curentVideos, setCurentVideos] = useState<ISVPlayer[]>();
    const [curentAudioSources, setCurentAudioSources] = useState<AudioBufferSourceNode[]>([]);
    const [curentGainNodes, setCurentGainNodes] = useState<any[]>([]);
    const [audioContext, setAudioContext] = useState<AudioContext>(new window.AudioContext());
    const [curentGroups, setCurentGroups] = useState<string[]>();
    const [curentGroup, setCurentGroup] = useState<string>();
    const [isPlayed, setIsPlayed] = useState<boolean>(false);
    const [isStudioVerse, setIsStudioVerse] = useState<boolean>(true);
    const [isDebug] = useState<boolean>(false);
    const [isDebugShowAllVideos, setIsDebugShowAllVideos] = useState<boolean>(false);



    const fillAudioSources = (curPlayerList:ISVPlayer[]) => {

        var _audioContext = new window.AudioContext();
        var _audioSources: any[] = [];
        var _gainNodes: any[] = [];
        curPlayerList?.forEach((s, index) => {
            _gainNodes.push(_audioContext.createGain());
        });
        _gainNodes.forEach(gainNode => {
            gainNode.connect(_audioContext.destination);
        });

        curPlayerList?.forEach((s, index) => {
            fetch(AudioCDNDomain + s.audio)
                .then(response => response.arrayBuffer())
                .then(arrayBuffer => _audioContext.decodeAudioData(arrayBuffer))
                .then(audioBuffer => {
                    var source = _audioContext.createBufferSource();
                    source.buffer = audioBuffer;
                    source.loop = true;
                    source.connect(_gainNodes[index]);
                    _audioSources[index] = source;
                })
                .catch(error => console.error('Error loading audio file:', error));
        });

        setAudioContext(_audioContext);
        setCurentAudioSources(_audioSources);
        setCurentGainNodes(_gainNodes);
    }
    //const seekSlider: any = document.getElementById('seek-slider');
    const selectisStudioVerse = (isStudioVerse:boolean) => {
        if(!isPlayed)
            return;
        if(!isStudioVerse){
            let byPassTrack = curentVideos?.find(f=>f.isBypass );
            PlayToogleClick(byPassTrack,byPassTrack?.ind);
        }
        else{
            const lastTrack = selectedStylePlayer;
            PlayToogleClick(lastTrack,lastTrack?.ind);
        }

        setIsStudioVerse(isStudioVerse);
    };
    const setGroups = (curPlayerList:ISVPlayer[]) => {
        const groupedData = groupBy(curPlayerList, 'group');
        const groupedArray = keys(groupedData);
        if(groupedArray && groupedArray.length > 0)
            setCurentGroups(groupedArray);
    }

    const selectCurrentGroup = (group: string) => {
        let curPlayerList = props?.svPlayerSources?.filter(f=>f.group === group );

        if(curPlayerList) {
            if(isPlayed) {
                toogleToStop();
                setIsPlayed(false);
            }
            setIsFirstTimeSelected(false);
            setCurentVideos(curPlayerList);
            setCurentGroup(group);
            setCurrentPlayer(curPlayerList[0]);
            setSelectedStylePlayer(curPlayerList[0]);
            setIsStudioVerse(true);
            fillAudioSources(curPlayerList);
        }
    }
    const selectCurrentPlayer2 = (svPlayer: ISVPlayer, isPlay:boolean = true, isStudioVerse:boolean = false) => {
        //console.log('selectCurrentPlayer2: ',svPlayer?.ind,svPlayer?.id);
        setCurrentPlayer(svPlayer);
        setSelectedStylePlayer(svPlayer);
        setIsPlayed(true);
        setIsStudioVerse(true);
        if(!isFirstTimeSelected || (props?.svPlayerType === svPlayerType.instruments && svPlayer.ind === currentPlayer?.ind)) {
            PlayToogleClick(svPlayer);
        }
        else {
            PlayToogleClick(svPlayer,svPlayer.ind);
        }
    };
    const PlayToogleClick = (svPlayer : ISVPlayer | undefined, trackInd = -1) => {
        if(svPlayer === undefined && currentPlayer !== undefined)
            svPlayer = currentPlayer;
        if(!svPlayer)
            return;
        //console.log('PlayToogleClick: ',curentAudioSources, curentGainNodes);
        if(!currentPlayer && selectedStylePlayer) {
            setCurrentPlayer(cloneDeep(selectedStylePlayer));
        }
        if(!isFirstTimeSelected)
            setIsFirstTimeSelected(true);


            if (trackInd !== -1) {
                if(props?.svPlayerType === svPlayerType.effects) {
                    changeAudio(trackInd);
                }
                if(props?.svPlayerType === svPlayerType.instruments) {
                    if (isPlayed){
                        toogleToStop();
                        toogleToPlay(svPlayer);
                    }

                }
                if (!isPlayed) {
                    toogleToPlay(svPlayer);
                    setIsPlayed(!isPlayed);
                }
            } else {
                if (isPlayed)
                    toogleToStop();
                else
                    toogleToPlay(svPlayer);
                setIsPlayed(!isPlayed);
            }

    };
    const changeAudio = (ind :number) => {
        var _curentGainNodes = cloneDeep(curentGainNodes);
        curentAudioSources.forEach((source, index) => {
            if (index !== ind) {
                // Mute audio1
                _curentGainNodes[index].gain.value = 0;
            } else {
                // Unmute audio2
                _curentGainNodes[index].gain.value = 1;
                //console.log('changeAudio: ',index);
            }

        });

    }
    const toogleToPlay = (svPlayer : ISVPlayer) => {
        //console.log('toogleToPlay: ',svPlayer?.ind);
        var _curentGainNodes = cloneDeep(curentGainNodes);
        var _curentAudioSources = cloneDeep(curentAudioSources);
        var _curentAudioSources_helper = cloneDeep(curentAudioSources);


        //rewrite source for unlimeter start/stop
        _curentAudioSources_helper.forEach((source, index) => {
            var newSource = audioContext.createBufferSource();
            newSource.buffer = source.buffer;
            newSource.connect(_curentGainNodes[index]);
            _curentAudioSources[index] = newSource;
        });

        // mute/unmute
        _curentAudioSources.forEach((source, index) => {
            if (index !== svPlayer?.ind) {
                // Mute audio1
                _curentGainNodes[index].gain.value = 0;
            } else {
                // Unmute audio2
                _curentGainNodes[index].gain.value = 1;
                //console.log('Unmute: ',index,svPlayer?.ind);
            }
            source.loop = true;
            source.start();
        });
        setCurentGainNodes(_curentGainNodes);
        setCurentAudioSources(_curentAudioSources);
    };
    const toogleToStop = () => {

        var _curentAudioSources = cloneDeep(curentAudioSources);
        _curentAudioSources.forEach(source => {
            if (source.context.state === 'running') {
                source.stop();
            }
            else
                source.stop();
        });
        setCurentAudioSources(_curentAudioSources);

    };




    useEffect(() => {
        let playListData = props?.svPlayerSources;
        if(playListData){
            var ind = 0;
            var _group = playListData[0]?.group;
            playListData.forEach(function(item, i, arr) {
                if(_group !== item.group) {
                    _group = item.group;
                    ind = 0;
                }
                item.id = `player-${props?.elId}-g-${item.group}-v-${i+1}`;
                item.ind = ind++;
            });
            const curGroup = playListData[0].group;
            let curPlayerList = playListData.filter(f=>f.group === curGroup );

            setCurentVideos(curPlayerList);
            setCurrentPlayer(curPlayerList[0]);
            setSelectedStylePlayer(curPlayerList[0])
            setCurentGroup(curPlayerList[0].group);
            setGroups(playListData);
            fillAudioSources(curPlayerList);

        }

    }, [props?.svPlayerSources, props?.elId]);


    return (
        <div className="sv-player flex flex-col">
            { isDebug &&
            <div className="flex flex-row">
                <div className="flex flex-col w-1/2">
                    <div>type:{props?.svPlayerType}</div>
                    <div>curentGroups count:{curentGroups?.length}</div>
                    <div>curentGroup:{curentGroup}</div>
                    <div>curentVideos:{curentVideos?.length}</div>
                    <div>curentAudioSources:{curentAudioSources?.length}</div>
                    <div>currentPlayer:{currentPlayer?.id}</div>
                    <div>selectedStylePlayer IND:{selectedStylePlayer?.ind}</div>
                    <div>selectedStylePlayer:{selectedStylePlayer?.id}</div>
                    <div>isFirstTimeSelected:{isFirstTimeSelected?.toString()}</div>
                    <div>isPlayed:{isPlayed.toString()}</div>
                    <div>isStudioVerse:{isStudioVerse.toString()}</div>
                </div>
                <div className="flex flex-col w-1/2">
                    <div className="flex flex-row items-center"><span>Show all video</span>
                        <Toggle
                            isChecked={isDebugShowAllVideos}
                            onChange={(isChecked: boolean) => setIsDebugShowAllVideos(isChecked)}
                            text={isDebugShowAllVideos ? 'On' : 'Off'}
                            isPositionRight={false}
                            textStyles={{
                                margiLeft: '-5px'
                            }}/>
                    </div>
                </div>
            </div>
            }
            <div className={`grid-container ${svPlayerType[props!.svPlayerType]}`}>

                    {curentVideos && curentVideos?.length > 0 &&
                    <ul className="item1-group grid md:flex gap-2 grid-cols-2 md:grid-cols-none h-fit pb-4">
                        {
                            curentGroups?.map((group, index) => {
                                return <button type="button"
                                    className={(curentGroup === group ? "bg-gray-200 " : "") + "p-3 cursor-pointer border border-gray-200 rounded-xl"}
                                    key={group}
                                    onClick={evt => {
                                        selectCurrentGroup(group);
                                    }}
                                >{group}</button>
                            })
                        }
                    </ul>
                    }
                {
                    curentVideos && curentVideos?.length > 0 &&
                    <ul className={`item2-audios flex flex-col justify-start w-full pr-0 md:pr-8`}>

                        {
                            curentVideos?.map((item, index) => {

                                const isLast = index + 1 === curentVideos?.length;
                                const isStudioVerseClass = item.isBypass ? "hidden" : "";
                                const selectedPlayerClass = item.id === selectedStylePlayer?.id ? "current-player bg-gray-100" : "";
                                const isLastClass = isLast ? "flex flex-row items-center" : "flex flex-row items-center border-b";
                                return (
                                    <li key={index}
                                        className={`${selectedPlayerClass} ${isStudioVerseClass} text-left cursor-pointer pt-3`}>
                                        <button type="button"
                                                onClick={evt => {
                                                    selectCurrentPlayer2(item);
                                                }}>
                                            <div
                                                className={`${isLastClass} flex flex-row items-center pb-3`}
                                                key={index}>

                                                <span className="w-20 relative">

                                                   <img src={ImageCDNDomain + item.thumb} alt={`For ${item.title}`}/>
                                                    { props?.svPlayerType === svPlayerType.instruments &&
                                                        <span className="absolute-center">
                                                            {
                                                                (!isFirstTimeSelected || !isPlayed || item.id !== currentPlayer?.id) &&
                                                                <PlayAudioIcon width="20" height="20" color="#000000" bgColor="#ffffff"/>
                                                            }
                                                            {
                                                                (isFirstTimeSelected && isPlayed && item.id === currentPlayer?.id) &&
                                                                <StopAudioIcon width="20" height="20" color="#000000" bgColor="#ffffff" />
                                                            }
                                                        </span>
                                                    }
                                                </span>
                                                <span
                                                    className="pl-8 pr-4 w-ellipsis">{item.title}
                                                </span>

                                            </div>
                                        </button>
                                    </li>
                                )
                            })
                        }
                        {
                            props?.svPlayerType === svPlayerType.effects &&
                            <li key={'play' + props?.elId} className="flex flex-row items-center pt-12">
                            <button type="button"
                                className={`w-btn ${isPlayed ? "bg-blue-d9dfff" : "bg-gray-200"} rounded-full w-32 p-3 md:p-4 lg:p-2 mt-0 md:mt-0 lg:mt-0 md:text-lg text-gray-700`}
                                onClick={evt => {
                                    PlayToogleClick(undefined);
                                }}
                            >
                                <span className="flex flex-row items-center justify-center">
                                    {
                                        (!isFirstTimeSelected || !isPlayed) &&
                                        <PlayAudioIcon width="20" height="20" color="#ffffff" bgColor="#000000"/>
                                    }
                                    {
                                        (isFirstTimeSelected && isPlayed) &&
                                        <StopAudioIcon width="20" height="20" color="#ffffff" bgColor="#000000"/>
                                    }
                                    <span className="pl-2">{!isFirstTimeSelected || !isPlayed ? 'Play' : 'Stop'}</span>
                                </span>
                            </button>
                            <span className="px-4">|</span>
                            <span className="flex flex-row items-center"> <span className="mr-1">StudioVerse</span>
                                <Toggle
                                    isChecked={isStudioVerse}
                                    handleColor={isStudioVerse ? '#D9DFFF' : '#686868'}
                                    onChange={selectisStudioVerse}
                                    text={isStudioVerse ? 'On' : 'Off'}
                                    isPositionRight={false}
                                    textStyles={{
                                        margiLeft: '-5px'
                                    }}/>
                            </span>
                        </li>
                        }
                    </ul>
                }
                {props?.svPlayerType === svPlayerType.effects && currentPlayer &&
                    <div
                        className={`item3-image bg-gray-100 hidden md:flex items-center justify-center`}>
                        <div><img data-text={isStudioVerse.toString()} className={isStudioVerse ? "" : "opacity-50"} src={ImageCDNDomain + currentPlayer?.svImage} alt={`For ${currentPlayer?.title}`}/></div>
                    </div>
                }
                {props?.svPlayerType === svPlayerType.instruments && currentPlayer &&
                    <div
                        className={`item3-image bg-gray-100 hidden md:flex items-center justify-center`}>
                        <div className="px-4"><img src={ImageCDNDomain + currentPlayer?.svImage} alt={`For ${currentPlayer?.title}`}/></div>
                    </div>
                }


                {isDebug && <div className="bg-gray-100 w-5/12">c
                    {
                        curentAudioSources?.map((item, index) => {
                            //var isOneVideoTrack = item;
                            //const isLast = index + 1 === curentAudioSources?.length;

                            var currentDebugClass = isDebug ? "" : "hidden1";
                            var currentPlayerClass = index === currentPlayer?.ind ? "current-player bg-red" : currentDebugClass;
                            if (isStudioVerse && index === curentAudioSources.length - 1)
                                currentPlayerClass = "current-player bg-red";
                            else if(isStudioVerse)
                                currentPlayerClass = "";
                            if (!isFirstTimeSelected && index === 0)
                                currentPlayerClass = "";
                            return (
                                <div key={'v-' + index}
                                     className={currentPlayerClass + ' border border-grey-500 mb-4'}>
                                    <div className="py-2" id={"ct-" + index}></div>

                                    <div>ind: {index}</div>
                                    <div>state: {item.context.state}</div>
                                </div>
                            )
                        })
                    }
                </div>}
            </div>
        </div>
    )
};

export default SVPlayer2;
